/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import win from '../../../shared/win';

import { paymentFields } from '../../../shared/form-lib';

export const defaultState = {
  showFormNameModal: false,
  isPremium: false,
  plan: win.PLAN,
  vm: {
    fields: paymentFields,
    authorizePaymentNag: false,
    missing_credentials: [],
    showNag: false,
  },
  flutterwave_credentials: null,
  paymentCrendtialModal: false,
  paystack_credentials: null,
  confirmClearPremium: false,
  stripe_credentials: null,
  paypal_credentials: null,
  disableHandler: false,
  requiredModal: false,
  optionsError: '',
  newFormId: null,
};

const formValidationSlice = createSlice({
  name: 'formValidations',
  initialState: defaultState,
  reducers: {
    checkUserVm: (state, action) => {
      return {
        ...state,
        vm: {
          ...state.vm,
          ...action.payload,
        },
      };
    },
    updateCredential: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    externalSave: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    showFormError: (state, action) => {
      const { formError } = action.payload;
      state.formError = formError;
    },
    disableHandler: (state) => {
      state.disableHandler = true;
    },
    saveAction: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    paymentCredentialMissingModal: (state, action) => {
      state.paymentCrendtialModal = action.payload;
    },
    showClearPremiumModal: (state, action) => {
      state.confirmClearPremium = false;
    },
    updatePlan: (state, action) => {
      state.plan = action.payload;
    },
    doShowFormNameModal: (state, action) => {
      state.showFormNameModal = action.payload;
    },
    checkPaymentCredentials: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

const { reducer } = formValidationSlice;
export default reducer;

export const {
  paymentCredentialMissingModal,
  checkPaymentCredentials,
  showClearPremiumModal,
  doShowFormNameModal,
  updateCredential,
  disableHandler,
  showFormError,
  externalSave,
  checkUserVm,
  saveAction,
  updatePlan,
} = formValidationSlice.actions;
